module.exports = __webpack_public_path__ + "img/bio2.ed3f7a50.png";